module.exports = __webpack_public_path__ + "img/time.7f9aa153.svg";